import api from "APP_ROOT/api";
import { SUCCESS } from "LIB/submission/constants";
import { toastr } from "react-redux-toastr";
import { REFRESH_CACHED_SALES_CARTS } from "MODULES/session/actionTypes";
import * as actionTypes from "./actionTypes";
import pagination from "./pagination";

export const { search, setFilter, pageActions } = pagination;

export function convertFromOutgoingQuote(params, history) {
  return dispatch =>
    api.salesOrders.convertFromOutgoingQuote(params).then(({ data }) => {
      dispatch({
        type: REFRESH_CACHED_SALES_CARTS,
        cachedSalesCart: data.cached_sales_cart,
        salesCartItems: data.sales_order_cart_items
      });
      history.push("/sales-orders/reserved");
    });
}

export function setFollowUp(id, params, close) {
  return dispatch =>
    api.outgoingQuotes.autoFollowup(id, params).then(resp => {
      dispatch({
        type: actionTypes.SET,
        outgoingQuote: resp.data
      });
      close();
      toastr.success("Success", "Follow Up Scheduled.");
    });
}

export function sendEmail(id, params, close) {
  return dispatch =>
    api.outgoingQuotes
      .send(id, params)
      .then(resp => {
        close();
        dispatch({
          type: actionTypes.SET,
          outgoingQuote: resp.data
        });
        toastr.success("Success", "Quote queued to be sent.");
      })
      .catch(() =>
        toastr.error(
          "Error",
          "Could not send quote. Please refresh page and try again."
        )
      );
}

export function show(id) {
  return dispatch =>
    api.outgoingQuotes.show(id).then(resp =>
      dispatch({
        type: actionTypes.SET,
        outgoingQuote: resp.data
      })
    );
}

export function getCompany(id) {
  return api.companies.show(id).then(resp => Promise.resolve(resp.data));
}

export function updateOutgoingQuote(data) {
  return (dispatch, getState) => {
    const quoteID = getState().outgoingQuoteDetail.getIn([
      "outgoingQuote",
      "id"
    ]);

    return api.outgoingQuotes.update(quoteID, data).then(() => {
      dispatch(show(quoteID));
      dispatch(pageActions.expire());
      return SUCCESS;
    });
  };
}

export function createOutgoingQuoteLineItem(data) {
  return (dispatch, getState) => {
    const quoteID = getState().outgoingQuoteDetail.getIn([
      "outgoingQuote",
      "id"
    ]);

    return api.outgoingQuotes.lineItems.create(quoteID, data).then(() => {
      dispatch(show(quoteID));
      return SUCCESS;
    });
  };
}

export function updateOutgoingQuoteLineItem(data, itemID) {
  return (dispatch, getState) => {
    const quoteID = getState().outgoingQuoteDetail.getIn([
      "outgoingQuote",
      "id"
    ]);

    return api.outgoingQuotes.lineItems.update(itemID, data).then(() => {
      dispatch(show(quoteID));
      return SUCCESS;
    });
  };
}

export function deleteOutgoingQuoteLineItem(id) {
  return (dispatch, getState) => {
    const quoteID = getState().outgoingQuoteDetail.getIn([
      "outgoingQuote",
      "id"
    ]);
    api.outgoingQuotes.lineItems.delete(id).then(() => dispatch(show(quoteID)));
  };
}

export function send() {
  return (_, getState) => {
    const outgoingQuoteID = getState().outgoingQuoteDetail.getIn([
      "outgoingQuote",
      "id"
    ]);
    return api.outgoingQuotes
      .send(outgoingQuoteID)
      .then(() => Promise.resolve())
      .catch(err => Promise.reject(err));
  };
}



// WEBPACK FOOTER //
// ./app/modules/OutgoingQuotes/actions.js